import { Link } from "react-router-dom";
import { ShieldCheck, Calendar, Camera, ClipboardList, BarChart3, Smartphone, ArrowRight } from "lucide-react";
import MarketingLayout from "../../components/MarketingLayout";
import { Brand } from "../../context/CompanyContext";

export default function Solucao() {
  const features = [
    { Icon: Calendar, title: "Calendário inteligente",
      body: "Reservas e limpezas sincronizadas com check-in/out automáticos." },
    { Icon: ClipboardList, title: "Checklists hoteleiras",
      body: "50+ pontos de controlo por tipologia (T0, T1, T2, T3+)." },
    { Icon: Camera, title: "Relatórios fotográficos",
      body: "Antes e depois de cada limpeza no seu telemóvel em tempo real." },
    { Icon: Smartphone, title: "App para a equipa",
      body: "Funcionários recebem ordens, fotografam, e fecham tudo no telemóvel." },
    { Icon: BarChart3, title: "Dashboard financeiro",
      body: "Receitas, despesas e IVA da Madeira separados por apartamento." },
    { Icon: ShieldCheck, title: "Fluxo de aprovação",
      body: "Validação dos relatórios pelo cliente antes da fatura final." },
  ];

  return (
    <MarketingLayout>
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <span className="inline-block text-xs uppercase tracking-[0.22em] text-[#d4af37]">A nossa solução</span>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl tracking-tight text-[#fdfbf7] leading-tight">
          Tudo o que precisa para gerir os seus alojamentos como um <span className="italic text-[#d4af37]">hotel</span>
        </h1>
        <p className="mt-5 text-lg text-[#a0b2af] max-w-2xl">
          A <Brand short /> combina equipa de limpeza profissional na Madeira com uma plataforma digital
          que organiza calendário, checklists, fotos, faturação e financeiro num só sítio.
        </p>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map(({ Icon, title, body }) => (
            <article key={title} className="bg-[#062c27] p-6 rounded-2xl border border-[#1a4640] hover:border-[#d4af37]/60 hover:shadow-lg hover:shadow-[#d4af37]/10 transition-all duration-200">
              <div className="w-11 h-11 rounded-xl bg-[#d4af37]/15 grid place-items-center text-[#d4af37]">
                <Icon size={20} />
              </div>
              <h3 className="mt-4 font-display text-lg text-[#fdfbf7]">{title}</h3>
              <p className="mt-1.5 text-sm text-[#a0b2af] leading-relaxed">{body}</p>
            </article>
          ))}
        </div>

        <Link to="/#contacto"
              className="mt-12 inline-flex items-center gap-2 px-7 py-4 rounded-sm text-[#031411] bg-[#d4af37] hover:bg-[#f5d76e] font-semibold uppercase tracking-widest text-sm shadow-lg shadow-[#d4af37]/20 transition-colors"
              data-testid="solucao-cta">
          Pedir orçamento gratuito <ArrowRight size={18} />
        </Link>
      </section>
    </MarketingLayout>
  );
}
